import { env } from '../../lib/env/env';

const GATEWAY_URL = env.getString('GATEWAY_URL') || 'http://localhost:9089';
export const legacyC2foApiConfig = {
  LEGACY_C2FO_UI_BASE_URL: `${GATEWAY_URL}/api/c2fo`,
};
